<template>
  <div class="CCBTables">
    <v-container grid-list-md fluid fill-height>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-layout align-center justify-center column fill-height>
            <v-flex xs10>
              <v-btn
                color="info"
                :disabled="substitution === 0 && substitution !== null"
                @click="changeData(0)"
              >
                <span>Base</span>
              </v-btn>
              <v-btn
                color="info"
                :disabled="substitution === 1 && substitution !== null"
                @click="changeData(1)"
              >
                <span>Sustitución</span>
              </v-btn>
            </v-flex>

            <v-flex xs10>
              <v-switch
                v-model="stratus"
                :label="stratus ? 'Estrato: activo' : 'Estrato: inactivo'"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <v-card class="pa-2">
            <v-card-text>
              <v-layout wrap justify-space-between>
                <v-flex xs12 md3>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuFI"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    :disabled="loading"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Inicial"
                      v-model="dateFI"
                      prepend-icon="event"
                      readonly
                      hint="Debe ser anterior a la fecha final"
                      persistent-hint
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateFI"
                      locale="es-CO"
                      no-title
                      scrollable
                      actions
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-spacer/>

                <v-flex xs12 md3>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuFF"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    :disabled="loading"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Final"
                      v-model="dateFF"
                      prepend-icon="event"
                      readonly
                      hint="Debe ser posterior a la fecha inicial"
                      persistent-hint
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateFF"
                      locale="es-CO"
                      no-title
                      scrollable
                      actions
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-spacer/>

                <v-flex xs12 md3>
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn color="warning"
                      :disabled="loading"
                      @click="clear()"
                    >
                      Limpiar
                    </v-btn>

                    <v-btn
                      color="info"
                      :disabled="loading || vDate || substitution === null"
                      @click="loadData()"
                    >
                      <v-icon left>cloud_download</v-icon> {{ btnText }}
                    </v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card class="mb-2">
            <v-card-title class="title" justify-space-between>
              {{ textIMRC }}
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataValsIMRC === null">
                  <download-csv
                    :data="dataValsIMRC"
                    :name="textIMRC + '.csv'"
                    :labels="stratus ? labelsISMRCce : labelsISMRC"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <!-- <v-card-actions>
              <v-layout row justify-space-around>
                <v-flex xs11 sm3>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuISMRCI"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Inicial"
                      v-model="dateISMRCI"
                      prepend-icon="event"
                      readonly
                      hint="Debe ser anterior a la fecha final"
                      persistent-hint
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateISMRCI"
                      locale="es-CO"
                      no-title
                      scrollable
                      actions
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs11 sm3>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuISMRCF"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Final"
                      v-model="dateISMRCF"
                      prepend-icon="event"
                      readonly
                      hint="Debe ser posterior a la fecha inicial"
                      persistent-hint
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateISMRCF"
                      locale="es-CO"
                      no-title
                      scrollable
                      actions
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-spacer/>
              <v-btn
                color="info"
                :disabled="!dateISMRCI || !dateISMRCF || !vDateISMRC"
                @click="loadTableIMRC"
              >
                <v-icon left>cloud_download</v-icon>Cargar
              </v-btn>
            </v-card-actions> -->

            <v-card-text
              v-if="loadingISMRC"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="stratus ? headersISMRCce : headersISMRC"
                :dataVals="dataValsIMRC"
                :key="tableISMRCKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card class="mb-2">
            <v-card-title class="title" justify-space-between>
              {{ textRL }}
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataValsRLI === null">
                  <download-csv
                    :data="dataValsRLI"
                    :name="textRL + '.csv'"
                    :labels="stratus ? labelsRSLIce : labelsRSLI"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <!-- <v-card-actions>
              <v-layout row justify-space-around>
                <v-flex xs11 sm3>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuRSLI"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Inicial"
                      v-model="dateRSLI"
                      prepend-icon="event"
                      readonly
                      hint="Debe ser anterior a la fecha final"
                      persistent-hint
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateRSLI"
                      locale="es-CO"
                      no-title
                      scrollable
                      actions
                   ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs11 sm3>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menuRSLF"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha Final"
                      v-model="dateRSLF"
                      prepend-icon="event"
                      readonly
                      hint="Debe ser posterior a la fecha inicial"
                      persistent-hint
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateRSLF"
                      locale="es-CO"
                      no-title
                      scrollable
                      actions
                   ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-spacer/>
              <v-btn
                color="info"
                :disabled="!dateRSLI || !dateRSLF || !vDateRSL"
                @click="loadTableRL"
              >
                <v-icon left>cloud_download</v-icon>Cargar
              </v-btn>
            </v-card-actions> -->

            <v-card-text
              v-if="loadingRSLI"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="stratus ? headersRSLIce : headersRSLI"
                :dataVals="dataValsRLI"
                :key="tableRSLKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card class="mb-2">
            <v-card-title class="title">
              {{ textBase }}
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataValsTotal.length === 0">
                  <download-csv
                    :data="dataValsTotal"
                    :name="textBase + '.csv'"
                    :labels="stratus ? labelsTotalce : labelsTotal"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingTotal"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-if="!loadingTotal && dataValsTotal.length !== 0">
              <data-table
                :headers="stratus ? headersTotalce : headersTotal"
                :dataVals="dataValsTotal"
                :key="tableTotalKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableWithTotals'
import JsonCSV from 'vue-json-csv'
import moment from 'moment'

export default {
  name: 'CCBTables',

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
  },

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  data: function () {
    return {
      backConf: {
        path: '/ccb/reportes',
        page: 1
      },

      operativo: null,

      progressSize: 70,
      progressWidth: 7,

      loadingISMRC: false,
      loadingRSLI: false,
      loadingTotal: false,

      menuFI: false,
      dateFI: null,
      menuFF: false,
      dateFF: null,

      dateISMRCI: null,
      dateISMRCF: null,
      tableISMRCKey: 0,
      btnLoadISMRC: true,

      dateRSLI: null,
      dateRSLF: null,
      tableRSLKey: 0,

      tableTotalKey: 0,

      menuISMRC: false,
      menuRSL: false,

      headersISMRC: [
        {
          text: 'Nombre Localidad',
          align: 'left',
          value: 'localidad',
          str: 'Totales'
        },
        { text: 'Id. Manzana cerrada', value: 'mnzcerrada', enu: true },
        { text: 'Viv. seleccionadas', value: 'vivSel' },
        { text: 'Viv. visitadas ocupadas', value: 'vivOcu' },
        { text: 'Viv. desocupadas', value: 'vivDes' },
        { text: 'Viv. no encontradas', value: 'vivNE' },
        { text: 'Viv. otros usos', value: 'vivUsos' },
        { text: 'Viv. otros - no me permiten el acceso', value: 'noAcceso' },
        { text: 'Hgr. encontrados', value: 'encontrados' },
        { text: 'Hgr. encuestados completos', value: 'encuestadosComp' },
        { text: 'Hgr. encuestados incompletos', value: 'encuestadosInco' },
        { text: 'Hgr. rechazados', value: 'rechazados' },
        { text: 'Hgr. con encuestado ausente', value: 'ausentes' },
        { text: 'Otros - no me pueden atender', value: 'noPuede' }
      ],
      labelsISMRC: {
        localidad: 'Nombre localidad',
        mnzcerrada: 'Manzanas cerradas',
        vivSel: 'Viviendas seleccionadas',
        vivOcu: 'Viviendas visitadas ocupadas',
        vivDes: 'Viviendas desocupadas',
        vivNE: 'Viviendas no encontradas',
        vivUsos: 'Viviendas otros usos',
        noAcceso: 'Viviendas otros - no me permiten el acceso',
        encontrados: 'Hogares encontrados',
        encuestadosComp: 'Hogares encuestados completos',
        encuestadosInco: 'Hogares encuestados incompletos',
        rechazados: 'Hogares rechazados',
        ausentes: 'Hogares con encuestado ausente',
        noPuede: 'Otros - no me pueden atender'
      },

      headersRSLI: [
        {
          text: 'Nombre Localidad',
          align: 'left',
          value: 'localidad',
          str: 'Totales'
        },
        { text: 'Total manzanas muestra', value: 'manzana' },
        { text: 'Mnz. visitadas', value: 'mnzvisitadas' },
        { text: 'Mnz. cerradas', value: 'mnzcerrada' },
        { text: 'Viv. seleccionadas', value: 'vivSel' },
        { text: 'Viv. visitadas ocupadas', value: 'vivOcu' },
        { text: 'Viv. desocupadas', value: 'vivDes' },
        { text: 'Viv. no encontradas', value: 'vivNE' },
        { text: 'Viv. otros usos', value: 'vivUsos' },
        { text: 'Viv. otros - no me permiten el acceso', value: 'noAcceso' },
        { text: 'Hgr. encontrados', value: 'encontrados' },
        { text: 'Hgr. encuestados completos', value: 'encuestadosComp' },
        { text: 'Hgr. encuestados incompletos', value: 'encuestadosInco' },
        { text: 'Hgr. rechazados', value: 'rechazados' },
        { text: 'Hgr. con encuestado ausente', value: 'ausentes' },
        { text: 'Otros - no me pueden atender', value: 'noPuede' }
      ],
      labelsRSLI: {
        localidad: 'Nombre localidad',
        manzana: 'Total manzanas muestra',
        mnzvisitadas: 'Manzanas visitadas',
        mnzcerrada: 'Manzanas cerradas',
        vivSel: 'Viviendas seleccionadas',
        vivOcu: 'Viviendas visitadas ocupadas',
        vivDes: 'Viviendas desocupadas',
        vivNE: 'Viviendas no encontradas',
        vivUsos: 'Viviendas otros usos',
        noAcceso: 'Viviendas otros - no me permiten el acceso',
        encontrados: 'Hogares encontrados',
        encuestadosComp: 'Hogares encuestados completos',
        encuestadosInco: 'Hogares encuestados incompletos',
        rechazados: 'Hogares rechazados',
        ausentes: 'Hogares con encuestado ausente',
        noPuede: 'Otros - no me pueden atender'
      },

      headersTotal: [
        {
          text: 'Nombre localidad',
          align: 'left',
          value: 'localidad',
          str: 'Totales'
        },
        { text: 'Total manzanas muestra', value: 'manzana' },
        { text: 'Mnz. visitadas', value: 'mnzvisitadas' },
        { text: 'Mnz. cerradas', value: 'mnzcerrada' },
        { text: 'Viv. seleccionadas', value: 'vivSel' },
        { text: 'Viv. visitadas ocupadas', value: 'vivOcu' },
        { text: 'Viv. desocupadas', value: 'vivDes' },
        { text: 'Viv. no encontradas', value: 'vivNE' },
        { text: 'Viv. otros usos', value: 'vivUsos' },
        { text: 'Viv. otros - no me permiten el acceso', value: 'noAcceso' },
        { text: 'Hgr. encontrados', value: 'encontrados' },
        { text: 'Hgr. encuestados completos', value: 'encuestadosComp' },
        { text: 'Hgr. encuestados incompletos', value: 'encuestadosInco' },
        { text: 'Hgr. rechazados', value: 'rechazados' },
        { text: 'Hgr. con encuestado ausente', value: 'ausentes' },
        { text: 'Otros - no me pueden atender', value: 'noPuede' }
      ],
      labelsTotal: {
        localidad: 'Nombre localidad',
        manzana: 'Total manzanas muestra',
        mnzvisitadas: 'Manzanas visitadas',
        mnzcerrada: 'Manzanas cerradas',
        vivSel: 'Viviendas seleccionadas',
        vivOcu: 'Viviendas visitadas ocupadas',
        vivDes: 'Viviendas desocupadas',
        vivNE: 'Viviendas no encontradas',
        vivUsos: 'Viviendas otros usos',
        noAcceso: 'Viviendas otros - no me permiten el acceso',
        encontrados: 'Hogares encontrados',
        encuestadosComp: 'Hogares encuestados completos',
        encuestadosInco: 'Hogares encuestados incompletos',
        rechazados: 'Hogares rechazados',
        ausentes: 'Hogares con encuestado ausente',
        noPuede: 'Otros - no me pueden atender'
      },

      headersISMRCce: [
        {
          text: 'Nombre Localidad',
          align: 'left',
          value: 'localidad',
          str: 'Totales'
        },
        { text: 'Estrato', value: 'estrato', str: ' ' },
        { text: 'Id. Manzana cerrada', value: 'mnzcerrada', enu: true },
        { text: 'Viv. seleccionadas', value: 'vivSel' },
        { text: 'Viv. visitadas ocupadas', value: 'vivOcu' },
        { text: 'Viv. desocupadas', value: 'vivDes' },
        { text: 'Viv. no encontradas', value: 'vivNE' },
        { text: 'Viv. otros usos', value: 'vivUsos' },
        { text: 'Viv. otros - no me permiten el acceso', value: 'noAcceso' },
        { text: 'Hgr. encontrados', value: 'encontrados' },
        { text: 'Hgr. encuestados completos', value: 'encuestadosComp' },
        { text: 'Hgr. encuestados incompletos', value: 'encuestadosInco' },
        { text: 'Hgr. rechazados', value: 'rechazados' },
        { text: 'Hgr. con encuestado ausente', value: 'ausentes' },
        { text: 'Otros - no me pueden atender', value: 'noPuede' }
      ],
      labelsISMRCce: {
        localidad: 'Nombre localidad',
        estrato: 'Estrato Socioeconómico',
        mnzcerrada: 'Manzanas cerradas',
        vivSel: 'Viviendas seleccionadas',
        vivOcu: 'Viviendas visitadas ocupadas',
        vivDes: 'Viviendas desocupadas',
        vivNE: 'Viviendas no encontradas',
        vivUsos: 'Viviendas otros usos',
        noAcceso: 'Viviendas otros - no me permiten el acceso',
        encontrados: 'Hogares encontrados',
        encuestadosComp: 'Hogares encuestados completos',
        encuestadosInco: 'Hogares encuestados incompletos',
        rechazados: 'Hogares rechazados',
        ausentes: 'Hogares con encuestado ausente',
        noPuede: 'Otros - no me pueden atender'
      },

      headersRSLIce: [
        {
          text: 'Nombre Localidad',
          align: 'left',
          value: 'localidad',
          str: 'Totales'
        },
        { text: 'Estrato', value: 'estrato', str: ' ' },
        { text: 'Total manzanas muestra', value: 'manzana' },
        { text: 'Mnz. visitadas', value: 'mnzvisitadas' },
        { text: 'Mnz. cerradas', value: 'mnzcerrada' },
        { text: 'Viv. seleccionadas', value: 'vivSel' },
        { text: 'Viv. visitadas ocupadas', value: 'vivOcu' },
        { text: 'Viv. desocupadas', value: 'vivDes' },
        { text: 'Viv. no encontradas', value: 'vivNE' },
        { text: 'Viv. otros usos', value: 'vivUsos' },
        { text: 'Viv. otros - no me permiten el acceso', value: 'noAcceso' },
        { text: 'Hgr. encontrados', value: 'encontrados' },
        { text: 'Hgr. encuestados completos', value: 'encuestadosComp' },
        { text: 'Hgr. encuestados incompletos', value: 'encuestadosInco' },
        { text: 'Hgr. rechazados', value: 'rechazados' },
        { text: 'Hgr. con encuestado ausente', value: 'ausentes' },
        { text: 'Otros - no me pueden atender', value: 'noPuede' }
      ],
      labelsRSLIce: {
        localidad: 'Nombre localidad',
        estrato: 'Estrato Socioeconómico',
        manzana: 'Total manzanas muestra',
        mnzvisitadas: 'Manzanas visitadas',
        mnzcerrada: 'Manzanas cerradas',
        vivSel: 'Viviendas seleccionadas',
        vivOcu: 'Viviendas visitadas ocupadas',
        vivDes: 'Viviendas desocupadas',
        vivNE: 'Viviendas no encontradas',
        vivUsos: 'Viviendas otros usos',
        noAcceso: 'Viviendas otros - no me permiten el acceso',
        encontrados: 'Hogares encontrados',
        encuestadosComp: 'Hogares encuestados completos',
        encuestadosInco: 'Hogares encuestados incompletos',
        rechazados: 'Hogares rechazados',
        ausentes: 'Hogares con encuestado ausente',
        noPuede: 'Otros - no me pueden atender'
      },

      headersTotalce: [
        {
          text: 'Nombre localidad',
          align: 'left',
          value: 'localidad',
          str: 'Totales'
        },
        { text: 'Estrato', value: 'estrato', str: ' ' },
        { text: 'Total manzanas muestra', value: 'manzana' },
        { text: 'Mnz. visitadas', value: 'mnzvisitadas' },
        { text: 'Mnz. cerradas', value: 'mnzcerrada' },
        { text: 'Viv. seleccionadas', value: 'vivSel' },
        { text: 'Viv. visitadas ocupadas', value: 'vivOcu' },
        { text: 'Viv. desocupadas', value: 'vivDes' },
        { text: 'Viv. no encontradas', value: 'vivNE' },
        { text: 'Viv. otros usos', value: 'vivUsos' },
        { text: 'Viv. otros - no me permiten el acceso', value: 'noAcceso' },
        { text: 'Hgr. encontrados', value: 'encontrados' },
        { text: 'Hgr. encuestados completos', value: 'encuestadosComp' },
        { text: 'Hgr. encuestados incompletos', value: 'encuestadosInco' },
        { text: 'Hgr. rechazados', value: 'rechazados' },
        { text: 'Hgr. con encuestado ausente', value: 'ausentes' },
        { text: 'Otros - no me pueden atender', value: 'noPuede' }
      ],
      labelsTotalce: {
        localidad: 'Nombre localidad',
        estrato: 'Estrato Socioeconómico',
        manzana: 'Total manzanas muestra',
        mnzvisitadas: 'Manzanas visitadas',
        mnzcerrada: 'Manzanas cerradas',
        vivSel: 'Viviendas seleccionadas',
        vivOcu: 'Viviendas visitadas ocupadas',
        vivDes: 'Viviendas desocupadas',
        vivNE: 'Viviendas no encontradas',
        vivUsos: 'Viviendas otros usos',
        noAcceso: 'Viviendas otros - no me permiten el acceso',
        encontrados: 'Hogares encontrados',
        encuestadosComp: 'Hogares encuestados completos',
        encuestadosInco: 'Hogares encuestados incompletos',
        rechazados: 'Hogares rechazados',
        ausentes: 'Hogares con encuestado ausente',
        noPuede: 'Otros - no me pueden atender'
      },

      dataValsIMRC: null,
      dataValsRLI: null,
      dataValsTotal: [],

      substitution: null,
      stratus: false,
      textIMRC: '',
      textRL: '',
      textBase: ''
    }
  },

  computed: {
    /**
     * Devuelve la fecha final a filtrar
     * @return {string} fecha de finalización de la consulta
     */
    'vDateISMRC': function vDateISMRC () {
      return moment(this.dateISMRCI).isBefore(this.dateISMRCF)
    },
    'vDateRSL': function vDateRSL () {
      return moment(this.dateRSLI).isBefore(this.dateRSLF)
    },

    /**
     * Verifica que la fecha final no sea anterior a la fecha inicial
     * @return {boolean} validación de las fechas
     */
    vDate: function vDate () {
      if (this.dateFI && this.dateFF) {
        return moment(this.dateFF).isBefore(this.dateFI)
      }
      return false
    },

    /**
     * Determina el texto que tendra el boton
     * @return {String} Texto poara poner en el boton
     */
    btnText: function btnText () {
      if (!this.dateFI && !this.dateFF) {
        return 'Cargar Todos'
      }
      return 'Cargar con Filtro'
    },

    /**
     * [loading description]
     * @return {[type]} [description]
     */
    loading: function loading () {
      return this.loadingISMRC || this.loadingRSLI || this.loadingTotal
    }
  },

  watch: {
    /** Si se cambia el estrato se actualiza la información de la tabla totales
     * Se eliminan datos de las tablas por localidad y recolección cerrada
     */
    stratus: function () {
      this.dateISMRCI = null
      this.dateISMRCF = null
      this.dateRSLI = null
      this.dateRSLF = null

      this.dataValsIMRC = null
      this.tableISMRCKey += 1
      this.dataValsRLI = null
      this.tableRSLKey += 1
    }
  },

  methods: {
    /**
     * Carga la tabla Informe Semanal por Manzana con Recolección Cerrada
     * desde el back y actualiza el componente
     */
    loadTableIMRC () {
      this.loadingISMRC = true
      this.dataValsIMRC = null
      let request = {
        method: 'post',
        data: {
          informe: 'manzanas',
          num_cargue: this.substitution,
          fechainicio: this.dateFI,
          fechafin: this.dateFF,
          estrato: this.stratus,
          operativo: this.operativo
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsIMRC = resp.data
          t.loadingISMRC = false
          t.tableISMRCKey += 1
        })
        .catch(function (err) {
          t.dataValsIMRC = []
          t.loadingISMRC = false
          console.error(err)
        })
    },

    /**
     * Carga la tabla  Resumen Semanal por Localidad
     * desde el back y actualiza el componente
     */
    loadTableRL () {
      this.loadingRSLI = true
      this.dataValsRLI = null
      let request = {
        method: 'post',
        data: {
          informe: 'localidad',
          num_cargue: this.substitution,
          fechainicio: this.dateFI,
          fechafin: this.dateFF,
          estrato: this.stratus,
          operativo: this.operativo
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsRLI = resp.data
          t.loadingRSLI = false
          t.tableRSLKey += 1
        })
        .catch(function (err) {
          t.dataValsRLI = []
          t.loadingRSLI = false
          console.error(err)
        })
    },

    /**
     * Carga la tabla Acumulado a la Fecha de Informes Semanales por Localidad
     * desde el back y actualiza el componente
     */
    loadTableTotal () {
      this.loadingTotal = true
      this.dataValsTotal = []
      let request = {
        method: 'post',
        data: {
          informe: 'total',
          num_cargue: this.substitution,
          fechainicio: this.dateFI,
          fechafin: this.dateFF,
          estrato: this.stratus,
          operativo: this.operativo
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataValsTotal = resp.data
          t.loadingTotal = false
          t.tableTotalKey += 1
        })
        .catch(function (err) {
          t.dataValsTotal = []
          t.loadingTotal = false
          console.error(err)
        })
    },

    /**
     * Cambia la muestra a procesar
     */
    changeData (muestra) {
      this.substitution = muestra

      this.dateISMRCI = null
      this.dateISMRCF = null

      this.dateRSLI = null
      this.dateRSLF = null

      this.textIMRC = 'Informe por Manzana con Recolección Cerrada'
      this.textRL = 'Resumen por Localidad'
      this.textBase = 'Acumulado a la Fecha por Localidad'

      switch (muestra) {
        case 1:
          this.textIMRC += ' (Sustitución)'
          this.textRL += ' (Sustitución)'
          this.textBase += ' (Sustitución)'
      }

      this.dataValsIMRC = null
      this.tableISMRCKey += 1
      this.dataValsRLI = null
      this.tableRSLKey += 1
    },

    /**
     * Ejecuta las funciones requeridas y cambia el estado de los filtros
     */
    loadData () {
      if (this.dateFI && this.dateFF) {
        this.loadTableIMRC()
        this.loadTableRL()
      }

      this.loadTableTotal()
    },

    /**
     * Limpia todos los campos
     */
    clear () {
      this.menuFI = false
      this.dateFI = null
      this.menuFF = false
      this.dateFF = null
    }
  }
}
</script>
